import i18next from 'i18next';
import { i18nLangOfGame } from 'locale/i18n';
import { bgTypes } from 'styles/generateBgStyleByType';
import { fever500, warning, system900, system100, white } from 'Mui/styles/color';
import { IS_EDITOR_MODE } from 'config/envVariable';
/**
 * 點數兌獎設計 - 主視覺
 * isShowKeyVision: boolean 顯示主視覺
 * isUseCustomKeyVision: boolean 使用主視覺圖片網址
 * customImgUrl: 自訂背景圖片 url (電腦)
 * customMobileImgUrl 自訂背景圖片 url (手機)
 * bgType: 主視覺背景類型 ( 1 : 顏色 / 2 : 圖片 / 3 : 文字＋背景  )
 * colorBg: string 背景顏色
 * froalaEditor: string 主視覺上的 html code 組成的文字
 **/

const translate = i18nKey => (IS_EDITOR_MODE ? i18nLangOfGame.t(i18nKey) : i18next.t(i18nKey));
export const defaultKeyVisionConfig = {
    isShowKeyVision: true,
    isUseCustomKeyVision: false,
    bgType: bgTypes.FROALA,
    colorBg: warning.color,
    customImgUrl: '',
    customMobileImgUrl: '',
    froalaEditor: `<h2 class="section-title" style="text-align: center;"> <span style="color:#FFF;"> <strong class="bold"> ${translate(
        'label.game_type_points_redeem'
    )} </strong> </span> </h2>`
};

/**
 * 點數兌獎設計 - 獎品樣式
 * colorText: string 文字顏色
 * colorBg: string 背景顏色
 * colorButtonText: string 按鈕文字顏色
 * colorButtonBg: string 按鈕背景顏色
 **/

export const defaultPrizeCardStyleConfig = {
    colorText: system900.color,
    colorBg: warning.color,
    colorButtonText: white.color,
    colorButtonBg: fever500.color
};

export const CARD_GAP_SIZE = 8;

/**
 * 點數兌獎設計/好禮自由選設計 - 獎品順序
 * prizesOrder: Prize[]
 **/
export const defaultPrizeOrderConfig = {
    prizesOrder: []
};

/**
 * 點數兌獎設計/好禮自由選設計 - 排列方式
 * desktop: x1, x2, x3, x4
 * mobile: x1, x2
 **/
export const defaultPrizeCardLayoutConfig = {
    desktop: 4,
    mobile: 2
};

/**
 * 點數兌獎設計/好禮自由選設計 - 背景
 * colorBg: string 背景顏色
 * isUseCustomImg: boolean 自訂樣式
 * customImgUrl: string 背景圖片
 **/
export const defaultBgStyleConfig = {
    colorBg: system100.color,
    isUseCustomImg: false,
    customImgUrl: ''
};

export const defaultAnimationSetting = {
    keyVision: defaultKeyVisionConfig,
    prizeCardLayout: defaultPrizeCardStyleConfig,
    prizeCardOrder: defaultPrizeOrderConfig,
    prizeCardStyle: defaultPrizeCardLayoutConfig,
    BackgroundStyle: defaultBgStyleConfig
};
